import React, { useState, useEffect } from "react";
import styles from "./Header.module.css";
import logo from "../../Assets/logo.png";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useSelector, useDispatch } from "react-redux";

import { setWalletAddress } from "../../redux/walletReducer";

function Header() {
  const location = useLocation();
  const [scrollBg, setScrollBg] = useState(false);
  const [openHeader, setOpenHeader] = useState(false);
  const [connected, toggleConnect] = useState(false);
  const [currAddress, updateAddress] = useState("0x");
  const dispatch = useDispatch();
  const { address } = useSelector((state) => state.wallet);

  function getAddress() {
    const ethers = require("ethers");
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    signer
      .getAddress()
      .then((res) => {
        updateAddress(res);
        dispatch(setWalletAddress(res));
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // function updateButton() {
  //   const ethereumButton = document.querySelector("#connectWallet");
  //   ethereumButton.textContent = "Connected";
  // }

  // async function connectWebsite() {
  //   const chainId = await window.ethereum.request({ method: "eth_chainId" });
  //   if (chainId !== "0x5") {
  //     //alert('Incorrect network! Switch your metamask network to Rinkeby');
  //     await window.ethereum.request({
  //       method: "wallet_switchEthereumChain",
  //       params: [{ chainId: "0x5" }],
  //     });
  //   }
  //   await window.ethereum
  //     .request({ method: "eth_requestAccounts" })
  //     .then(() => {
  //       // updateButton();
  //       // console.log("here");
  //       getAddress();
  //       window.location.replace(location.pathname);
  //     });
  // }

  async function connectWebsite() {
    if (null != window.ethereum) {
      const chainId = await window.ethereum.request({ method: "eth_chainId" });
      if (chainId !== "0x5") {
        //alert('Incorrect network! Switch your metamask network to Rinkeby');
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: "0x5" }],
        });
      }
      await window.ethereum
        .request({ method: "eth_requestAccounts" })
        .then(() => {
          // updateButton();
          // console.log("here");
          getAddress();
          window.location.replace(location.pathname);
        });
    }
  }
  useEffect(() => {
    if (null != window.ethereum) {
      let val = window.ethereum.isConnected();
      if (val) {
        // console.log("here");
        getAddress();
        toggleConnect(val);
      }

      window.ethereum.on("accountsChanged", function (accounts) {
        window.location.replace(location.pathname);
      });
    }
  });

  // useEffect(() => {
  //   let val = window.ethereum.isConnected();
  //   if (val) {
  //     // console.log("here");
  //     getAddress();
  //     toggleConnect(val);
  //   }

  //   window.ethereum.on("accountsChanged", function (accounts) {
  //     window.location.replace(location.pathname);
  //   });
  // });

  // useEffect(() => {
  //   // if (address) {
  //   // window.ethereum.on("connect", function () {
  //   const interval = setInterval(function () {
  //     if (window.ethereum) {
  //       let val = window.ethereum.isConnected();

  //       if (val) {
  //         clearInterval(interval);
  //       }

  //       if (val) {
  //         getAddress();
  //         toggleConnect(val);
  //         // updateButton();
  //       }
  //       window.ethereum.on("accountsChanged", function (accounts) {
  //         window.location.replace(location.pathname);
  //       });
  //     }
  //   }, 300);
  //   // });

  //   if (window.ethereum) {
  //   }
  //   // }
  // }, [address]);

  useEffect(() => {
    const scrollEvent = () => {
      if (window.scrollY > 100) {
        setScrollBg(true);
      } else {
        setScrollBg(false);
      }
    };
    window.addEventListener("scroll", scrollEvent);
    return () => {
      window.removeEventListener("scroll", scrollEvent);
    };
  }, []);

  return (
    <div className={`${styles.headerCont} ${scrollBg && styles.bgWhite}`}>
      <div
        className={`${styles.overlay} ${openHeader && styles.openOverlay}`}
        onClick={() => setOpenHeader(false)}
      ></div>
      <div className={styles.header}>
        <div className={styles.leftHeader}>
          <Link to={"/"}>
            <img src={logo} alt="" />
          </Link>
          <input type="text" placeholder="search item here" />
        </div>
        <div className={styles.rightHeader}>
          <div
            className={`${styles.navLinks} ${openHeader && styles.openHeader}`}
          >
            <Link onClick={() => setOpenHeader(false)} to={"/Explore"}>
              Explore
            </Link>
            <Link onClick={() => setOpenHeader(false)} to={"/Profile"}>
              Activity
            </Link>
            <Link onClick={() => setOpenHeader(false)} to={"/Create"}>
              Create
            </Link>
          </div>
          <button
            id="connectWallet"
            className="cta-btn"
            onClick={connectWebsite}
          >
            {connected ? "Connected" : "Connect Wallet"}
          </button>
          <FontAwesomeIcon
            onClick={() => setOpenHeader((prev) => !prev)}
            className={styles.mobile}
            icon={openHeader ? faXmark : faBars}
          />
        </div>
      </div>
    </div>
  );
}

export default Header;
